<template>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Queue Rpa Base on Shipwithref</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
              aria-label="btn-close"></button>
          </div>
  
          <div class="modal-body">
            <div class="row">
                <div class="col-lg-4">
                    <h5>Status Processing: </h5> {{ status_processing }}
                </div>

                <div class="col-lg-4">
                    <h5>Status Queue : </h5> {{status_queue}}
                </div>

                <div class="col-lg-4">
                    <h5>Date Last Schedule Processing: </h5> {{date_last_schedule_processing}}
                </div>

            </div>
            <div class="row">
              <div class="table-responsive">
                <div class="table-container">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Status Queue</th>
                        <th>Pick Plan</th>
                        <th>Date Send RPA</th>
                        <th>Date Schedule</th>
                        <th>Date Receipt RPA</th>
                        <th>Createt at</th>
                        <th>Createt by</th>
                      </tr>
  
                    </thead>
  
                    <tbody>
                      <tr  v-for="row in rows"
                        :key="row">
                        <td>{{ row?.status_queue }}</td>
                        <td>{{ row?.pick_plan }}</td>
                        <td>{{ row?.date_send_rpa }}</td>
                        <td>{{ row?.date_schedule }}</td>
                        <td>{{ row?.date_receipt_rpa }}</td>
                        <td>{{ row?.createt_at }}</td>
                        <td>{{ row?.create_by }}</td>
                        
                      </tr>
                    </tbody>
                </table>
                </div>
               
              </div>
            </div>
  
            <br>
  
            
            <br>
            
  
  
  
          </div>
  
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
              close
            </button>
            <!-- <button class="btn btn-success" type="submit" v-on:click="saveAssign">
              <span v-if="isLoading" class="spinner-border spinner-border-sm ms-auto" role="status"
                aria-hidden="true"></span>Save
            </button> -->
          </div>
  
        </div>
      </div>
  
          <!-- <modal-add-free-pick
            :showModal="showModalAdd" 
            :data="dataSendToModalAdd"
            :type="type_"
            @closeModal="closeMyModal">
          </modal-add-free-pick> -->
  
    </div>
  
    
  </template>
  
  <script>
//   import multiselect from "vue-multiselect";
//   import ModalAddFreePick from "@/components/modal/modalAddFreePick.vue";
  
  export default {
    components: {
    //   "multiselect": multiselect,
    //   "modal-add-free-pick":ModalAddFreePick
    },
    name: "ModalFreePick",
    emits: ["closeModal"],
    props: {
      showModal: Boolean,
      data: [],
    },
    watch: {
      showModal: {
        handler(newVal) {
            // console.log(this.data?.shipwithref);
          //   this.forms = {
          //       alert_id:this.data.alert_id,
          //       alert_setting_id:this.data.alert_setting_id,
          //       vehicle_no: this.data.vehicle_no,
          //       alert_time: this.data.alert_time,
          //       alert_type: this.data.alert_type,
          //       alert_value: this.data.alert_value,
          //       alert_subtype: this.data.alert_subtype,
          //       alert_off_reason: this.data.alert_off_reason,
          //     };
        
          this.active = newVal;

          if (this.active) {
            this.loadItems(this.data?.shipwithref);
          }
          const body = document.querySelector("body");
          this.showModal
            ? body.classList.add("modal-open")
            : body.classList.remove("modal-open");
        },
        immediate: true,
        deep: true,
      },
    },
    data() {
      return {
        dataSendToModalAdd:'',
        type_:'',
        showModalAdd:false,
        classColapsed: '',
        isLoading: false,
        active: this.showModal,
        forms: [],
        errors: [],
        locale: [],
        fetch_auto_load:[],
        auto_load:"",
        report_date: [],
        pickup_date: "",
        delivery_date: "",
        groupByCategory: [],
        type_error: [],
        rows: [],
        prioritycek: [],
        status_queue:'',
        status_processing:'',
        date_last_schedule_processing:'',
  
      };
    },
    methods: {
      resetForm() {
        this.forms = [];
      },
  
          loadDriver() {
        const baseURI =
          this.$settings.endPointCt + `master-driver/select`;
        return this.$http.get(baseURI).then((response) => {
          this.fetchDriver = response.data.datas.data;
  
        });
      },
  
      success2(msg) {
        this.$swal({
          icon: 'info',
          backdrop: true,
          title: "Information",
          html: "<p>* " + msg + "</p>",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      },
  
  
      errorAlert(msg) {
        this.$swal({
          icon: 'danger',
          backdrop: true,
          title: "Information",
          html: "<p>* " + msg + "</p>",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      },
  
      OpenNewDriver(){
        this.showModalAdd=this.$route.name;
        this.type_="driver";
        this.dataSendToModalAdd={
          transporter:this.transporter.carrier_code,
          vehicle_no:this.vehicle_no_vendor,
          driver:this.driver_vendor,
          typeTruck:this.typeTruck
        }
      },
  
      OpenNewVehicleNo(){
        this.showModalAdd=true;
        this.type_="truck";
        this.dataSendToModalAdd={
          transporter:this.transporter.carrier_code,
          vehicle_no:this.vehicle_no_vendor,
          driver:this.driver_vendor,
          typeTruck:this.typeTruck
        }
      },
  
   
  
      closeMyModal(){
        this.showModalAdd=false;
        this.fetchTransporter=[];
        this.loadTransporter();
  
        this.loadForCarrier(this.transporter.carrier_code);
        // this.transporter=[];
        // this.vehicle_no_vendor="";
        // this.driver_vendor="";
        // this.typeTruck="";
        // this.fetchDriverVendor='';
        // this.fetchVehicleNoVendor='';
        //this.loadTransporter();
      },
  
  
      
   
     
     
  
     
     
  
     
  
      loadItems(shipwith_ref) {
       
        this.rows = [];
        const baseURI = this.$settings.endPoint + "queue-rpa/get-schedule-rpa";
        return this.$http
          .post(
            baseURI,
            {
                "shipwithrefs"            : [shipwith_ref]
            },
            { timeout: 10000 }
          )
          .then((response) => {
  
            this.rows = response.data.datas[0].datas_schedule;
            // console.log(this.rows.length);
            this.status_queue=response.data.datas[0].status_queue;
            this.status_processing=response.data.datas[0].status_processing;
            this.date_last_schedule_processing=response.data.datas[0].date_last_schedule_processing;
  
  
  
  
  
            // this.totalRecords = response.data.datas.total;
            // this.isLoading = false;
          }).catch(error => {
            this.isLoading = false;
            if (error.code == "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
            } else {
  
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push('/server-error');
                } else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
                } else {
                  this.$router.push('/page-not-found');
                }
              }
  
            }
  
          });
      },
  
  
  
  
    },
    mounted() {
      //tail(this.data);
    },
  };
  </script>
  
  <style scoped>
  .modal {
    background: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left:0px !important;
  }
  
  .table-container {
      max-height: 100px; /* Set the maximum height for the table container */
      overflow-y: auto; /* Enable vertical scrolling */
  }
  </style>